import { createFileRoute, redirect } from '@tanstack/react-router';

import { CheckoutConfirmationV2 } from 'src/apps/checkout/app/V2/Confirmation';

export const Route = createFileRoute('/_auth/_only-header/store/confirmation')({
  beforeLoad: ({ context }) => {
    if (!context.featureFlags.EnableCheckoutV2) {
      throw redirect({
        to: '/store',
      });
    }
  },
  component: () => <CheckoutConfirmationV2 />,
});
